import { useState, useEffect } from 'react';
import './Header.css';

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container">
        <a href="#home" className="header__logo" onClick={close}>
          <span className="header__logo-icon">◈</span>
          <span className="header__logo-text">Ruxia Gold</span>
        </a>
        <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
          <a href="#home" className="header__nav-link" onClick={close}>Home</a>
          <a href="#prices" className="header__nav-link" onClick={close}>Aankoopprijzen</a>
          <a href="#products" className="header__nav-link" onClick={close}>Wat wij kopen</a>
          <a href="#about" className="header__nav-link" onClick={close}>Over ons</a>
          <a href="#contact" className="header__nav-link header__nav-link--cta" onClick={close}>Contact</a>
        </nav>
        <button
          className={`header__hamburger ${menuOpen ? 'header__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu openen"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
